/**
 * User: Rob
 * Date: 8/19/13
 */
"use strict";

var SoaModel = require('bunsen/models/SoaModel');
var Invoice = SoaModel.extend();
var root = typeof window === 'undefined' ? global : window;


var SoaCollection = require('bunsen/collections/SoaCollection');
var Backbone = require('dibs-backbone');
var _ = require('underscore');
var endpoints = require('dibs-endpoints');
var AdjustmentList = require('bunsen/models/ecomm/AdjustmentList');
var InvoiceItems = require('bunsen/collections/ecomm/InvoiceItems');
var Party = require('bunsen/models/Party');
var FinancialAmount = require('bunsen/models/FinancialAmount');
var financialAmountMixin = require('bunsen/models/mixins/financialAmountMixin');
var isType;
var getAdjustmentsTotalByFn;
var getItemsTotalByFn;

root.bunsen = root.bunsen || {};
module.exports = root.bunsen.Invoice = Invoice;

getAdjustmentsTotalByFn = function (fn, currency) {
    var adjustments = this.get('adjustments');
    if (!adjustments) {
        return null;
    }
    return adjustments[fn](currency);
};

getItemsTotalByFn = function (fn, currency) {
    var items = this.get('invoiceItems');
    if (!items) {
        return null;
    }
    return items[fn](currency);
};

isType = function (type) {
    return this.get('type') === type;
};

_.extend(Invoice, {
    STATUS_CANCELED: 'CANCELED',
    STATUS_SUBMITTED: 'SUBMITTED',
    STATUS_SETTLED: 'SETTLED',
    TYPE_BUYER: 'BUYER',
    TYPE_DEALER: 'DEALER',
    TYPE_LSP: 'LSP'
});

/**
 * @class Invoice
 * @extends SoaModel
 * @property idAttribute {string} - "id"
 */
_.extend(Invoice.prototype, {
    idAttribute: "id",
    defaults: {
        adjustments: {
            adjustments: []
        }
    },
    url : function () {
        return endpoints.invoice(this.get(this.idAttribute));
    },
    relations: [
        {
            type: Backbone.One,
            key: 'adjustments',
            relatedModel: AdjustmentList,
            collectionType: SoaCollection,
            omitFromSave: true
        },
        {
            type: Backbone.Many,
            key: 'invoiceItems',
            collectionType: InvoiceItems
        },
        {
            type: Backbone.One,
            key: 'seller',
            relatedModel: Party
        },
        {
            type: Backbone.One,
            key: 'subTotalAmount',
            relatedModel: FinancialAmount
        },
        {
            type: Backbone.One,
            key: 'totalAmount',
            relatedModel: FinancialAmount
        }
    ],
    calculateCommission: _.partial(getAdjustmentsTotalByFn, 'getCommissionTotal'),
    calculateProcessingFee: _.partial(getAdjustmentsTotalByFn, 'getProcessingFeeTotal'),
    calculateListingCredit: _.partial(getAdjustmentsTotalByFn, 'getListingCreditTotal'),
    calculateComplimentaryShipping: _.partial(getAdjustmentsTotalByFn, 'getComplimentaryShippingTotal'),
    calculatePromotion: _.partial(getAdjustmentsTotalByFn, 'getPromotionTotal'),
    calculateDealerCharge: _.partial(getAdjustmentsTotalByFn, 'getDealerChargeTotal'),

    calculateItemPriceModification: _.partial(getItemsTotalByFn, 'getItemPriceModification'),
    calculateProductCustomization: _.partial(getItemsTotalByFn, 'getProductCustomization'),
    calculateCustomerCharge: _.partial(getItemsTotalByFn, 'getCustomerCharge'),

    getListingCreditAdjustment: function () {
        var adjustmentList = this.get('adjustments');
        if (adjustmentList) {
            return adjustmentList.getListingCreditAdjustment();
        }
    },
    isDealerInvoice: _.partial(isType, Invoice.TYPE_DEALER),
    isBuyerInvoice: _.partial(isType, Invoice.TYPE_BUYER),
    isShipperInvoice: _.partial(isType, Invoice.TYPE_LSP)
}, financialAmountMixin);



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/Invoice.js
// module id = 81
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55